/* Pídelo Fácil — animación de entrada (sin dependencias) */
(function () {
  if (window.__pfInit) return;
  window.__pfInit = true;
  document.documentElement.classList.add('pf-js');
  var pendiente = false;
  function revisar() {
    pendiente = false;
    var limite = window.innerHeight * 0.95;
    document.querySelectorAll('.pf-reveal:not(.is-in), [data-pf-in]:not(.is-in)').forEach(function (e) {
      if (e.getBoundingClientRect().top < limite) e.classList.add('is-in');
    });
  }
  function pedir() { if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); } }
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', pedir);
  document.addEventListener('shopify:section:load', revisar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revisar); else revisar();
  window.addEventListener('load', revisar);
})();
